import Api from '@/modules/projectA/api/enquiry/index';
import Approve from '../approveDia.vue';
// import { yyhtUrl } from "@/assets/js/commonData";
// import Api form "@/modules/projectA/api/enquiry/index"; 是from 不是 form
export default {
  components: {
    Approve,
  },
  data() {
    return {
      ifSwitch: false,
      approvalList: [],
      activeApproval: {},
      approvalChain: {},
      authFlag: true,
      showAuditMask: false,
      noSwitch: false,
      auditId: '',
      approvalItem: {
        auditId: '',
        auditName: '',
      },
    };
  },
  created() {
    this.queryApprovalProcessSwitch();
  },
  methods: {
    // 获取审批信息
    async getApprovalList() {
      const params = {
        auditType: 5,
      };
      const res = await Api.approveList(params);
      if (res.code === '200') {
        this.approvalList = res.data;
        if (res.data.length === 1) {
          const [approvalItem] = this.approvalList;
          this.approvalItem = approvalItem;
          // this.approvalItem = this.approvalList[0];
        }
      }
    },

    // 配置审批流
    toSetApprove() {
      this.$router.push({ path: '/approveSetting' });
    },
    // 选择审批流程
    choiceAudit() {
      this.showAuditMask = true;
    },
    // 判断审批流的开关
    async queryApprovalProcessSwitch() {
      const res = await Api.queryOderConfig();
      if (res.code === '200') {
        if (res.data) {
          const { data } = res.data.find((item) => item.dataType === 'orderAsk');
          this.ifSwitch = data === '41';
          if (this.ifSwitch) {
            this.getApprovalList();
          }
        } else {
          this.ifSwitch = false;
        }
      }
    },
    choosenApproval() {
      this.showAuditMask = false;
      this.activeApproval = this.approvalChain;
    },
    // 获取审批详情信息
    async getItemPid(val) {
      const res = await Api.approveDetail({ auditId: val });
      if (res.code === '200') {
        this.approvalItem = res.data || {};
      }
    },
    closeDialog() {
      this.showAuditMask = false;
    },
    getApprovalChain(val) {
      this.approvalItem = val;
      console.log(this.approvalItem, 'approvalItem');
    },
  },
};
